import React from 'react';
import {TransformValues} from '../../utils/helper';
import {Tabs, TabsContent, TabsList, TabsTrigger} from '../../ui-components/Tabs/Tabs';
import 'react-color-palette/css';
import BackgroundReplacementColor from './backgroundReplacementColor';
import BackgroundReplacementTexture from './backgroundReplacementTexture';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {Button} from '../../ui-components/Button/button';
import {LockIcon} from '../../ui-components/Iconpack';
import {useNavigate} from 'react-router-dom';
import {TransformationType} from '../../screens/TransformationV2/Transformation';

interface BackgroundSubmenuProps {
    onTransformValuesChange: (values: {bgColorPalette?: string; backgroundImageUid?: string}) => void;
    transformationObject: TransformValues;
    addTransformation: (t: TransformationType) => void;
}

export default function BackgroundSubmenu({
    onTransformValuesChange,
    transformationObject,
    addTransformation,
}: BackgroundSubmenuProps) {
    const settingsProps = useSelector((state: RootState) => state.settings);
    const navigate = useNavigate();
    const goToPayment = () => {
        navigate('/settings/plans');
    };

    return (
        <>
            {!transformationObject.isSvgOrGif ? (
                <>
                    <div className='mb-4'>
                        <span className='text-[14px] font-[700] text-[#FFFFFF]'> Replace Background</span>
                    </div>
                    {settingsProps.allow_background_removal ? (
                        <Tabs defaultValue='texture'>
                            <TabsList>
                                <TabsTrigger value='texture'>Texture</TabsTrigger>
                                <TabsTrigger value='colour'>Colour</TabsTrigger>
                            </TabsList>
                            <TabsContent value='colour'>
                                <BackgroundReplacementColor
                                    onTransformValuesChange={onTransformValuesChange}
                                    transformationObject={transformationObject}
                                    addTransformation={addTransformation}
                                />
                            </TabsContent>
                            <TabsContent value='texture'>
                                <BackgroundReplacementTexture
                                    onTransformValuesChange={onTransformValuesChange}
                                    transformationObject={transformationObject}
                                    addTransformation={addTransformation}
                                />
                            </TabsContent>
                        </Tabs>
                    ) : (
                        <div className='relative'>
                            <div className='absolute inset-0 z-10 flex w-full flex-col items-center justify-center gap-5 bg-black bg-opacity-50'>
                                <span className='text-lg font-[700] text-[#FFFFFF]'>
                                    Upgrade to unlock background replacement
                                </span>
                                <Button
                                    className='bg-gradient-to-r from-[#FFB800] to-[#FFF500] font-[700] text-[#000000]'
                                    onClick={goToPayment}>
                                    <LockIcon />
                                    Upgrade
                                </Button>
                            </div>
                            <div className='z-0'>
                                <BackgroundReplacementTexture
                                    onTransformValuesChange={onTransformValuesChange}
                                    transformationObject={transformationObject}
                                    addTransformation={addTransformation}
                                />
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <div>
                    <div className='absolute inset-0 z-10 flex w-full flex-col items-center justify-center gap-5 bg-black bg-opacity-50'>
                        <span className='p-5 text-lg font-[700] text-[#FFFFFF]'>
                            Background replacement is not supported for this file type.{' '}
                        </span>
                    </div>
                    <div className='z-0'>
                        <BackgroundReplacementTexture
                            onTransformValuesChange={onTransformValuesChange}
                            transformationObject={transformationObject}
                            addTransformation={addTransformation}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
